'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { hostname } from '@haaretz/s-consts';
import Footer from '@haaretz/s-lite-footer';
import Masthead from '@haaretz/s-lite-masthead';
import PPChangeAccountBanner from '@haaretz/s-pp-change-account-banner';
import getCurrentStepName from '@haaretz/s-pp-routing-utils/getCurrentStepName';
import { BiDataContextProvider } from '@haaretz/s-use-bi';
import PPDataStoreContextProvider from '@haaretz/s-use-pp-data-store';
import PPDataStepsContextProvider from '@haaretz/s-use-pp-offset-steps-store';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import s9 from 'style9';
import PpPageSaver from './components/PpPageSaver';
import PpPageviewSender from './components/PpPageviewSender';
import PpSideEffects from './components/PpSideEffects';
const c = s9.create({
    wrapper: {
        minHeight: '100vh',
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto'
    },
    layout: {
        display: 'grid',
        justifyContent: 'center',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'max-content'
    }
});
const title = 'Haaretz Digital Subscriptions';
const description = "Haaretz digital subscriptions: Get the most reliable reporting on Israel, the Middle East and the Jewish world. Subscribe now to Israel's leading newspaper.";
const groupSubTitle = 'Organizational Subscription to Haaretz';
const groupSubDesc = 'Special offer to companies, organizations, schools and academic institutions - get full access to Haaretz';
export default function PurchasePageLayout({ children }) {
    const router = useRouter();
    const currentStepName = getCurrentStepName(router.pathname);
    const isGroupSub = currentStepName === 'groupSubscription';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PpSideEffects, {}),
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("title", {
                        children: isGroupSub ? groupSubTitle : title
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "description",
                        content: isGroupSub ? groupSubDesc : description
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "canonical",
                        href: `https://promotion.${hostname}/`
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: s9(c.wrapper),
                children: /*#__PURE__*/ _jsx(PPDataStoreContextProvider, {
                    children: /*#__PURE__*/ _jsxs(PPDataStepsContextProvider, {
                        children: [
                            /*#__PURE__*/ _jsx(PpPageSaver, {}),
                            /*#__PURE__*/ _jsxs(BiDataContextProvider, {
                                children: [
                                    /*#__PURE__*/ _jsx(PpPageviewSender, {}),
                                    /*#__PURE__*/ _jsx(Masthead, {}),
                                    /*#__PURE__*/ _jsxs("main", {
                                        className: s9(c.layout),
                                        children: [
                                            /*#__PURE__*/ _jsx(PPChangeAccountBanner, {}),
                                            children
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Footer, {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

//# sourceMappingURL=PpPageLayout.js.map